import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

/// styles
import { Slide } from '@mui/material';
import { resetMessageStore } from 'redux/Message/MessageActions';
import { useSnackbar } from 'notistack';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

const SnackbarNotification = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const MessageReducer = useSelector(state => state.MessageReducer);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let message = '';
    if (MessageReducer.messageKeys.length) {
      message = MessageReducer.messageKeys.map(mk => t(mk)).reduce((a, b) => a.concat(b) + ', ', '');
    } else if (MessageReducer.messages.length) {
      message = MessageReducer.messageKeys.reduce((a, b) => a.concat(b) + ' ', '');
    } else if (MessageReducer.messageKey) {
      message = t(MessageReducer.messageKey);
    } else {
      message = MessageReducer.message;
    }
    if (message) {
      enqueueSnackbar(message, {
        variant: MessageReducer.type,
        TransitionProps: SlideTransition,
        autoHideDuration: MessageReducer.autoHideDuration || 5000,
        preventDuplicate: Boolean(MessageReducer.preventDuplicate),
      });
      dispatch(resetMessageStore());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MessageReducer]);

  return null;
};

export default SnackbarNotification;
